import React, { useEffect } from 'react';

function LiveTV({ url, status }) {
  useEffect(() => {
    console.log(status);
    
    // Do something when url changes (if needed)
  }, [url]);

  return (
    <>
    {status === "IN_PLAY" ?
      <div key={url} dangerouslySetInnerHTML={{ __html: url }} />
    :''}
    </>
  );
}

// 👇 Memoize with custom comparison
export default React.memo(LiveTV, (prevProps, nextProps) => {
  return prevProps.url === nextProps.url;
});